/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useImperativeHandle } from 'react';
import Selector from '../Simple';
import ListView from './ListView';
import * as Ui from './styles';
import { isNullOrEmptyArray } from '../../../util/arrays';

function DetailedSelectorReferenciable(props, ref) {
  // props from parent
  const {
    // altera o modo de fundo do selector
    dark = false,
    // dados de apresentação no formato [{ label: string, value: string, data: [{label, value},...]}]
    data = [],
    // indica se o filtro de busca esta ativo
    enableFilter = false,
    // placeholder para o selector
    placeholder = null,
    // placeholder para o input do selector
    inputSearchPlaceholder = null,
    // permite selecionar o sub-item
    subItemSelectable = false,
    // usado para participar da seleção de um item no selector
    onSelectItem = null,
    // usado para participar da remoção de um item do listview
    onRemoveItem = null,
    // usado para participar de um evento de seleção de um subitem
    onSelectedSubItem = null,
    // usado para participar de um evento de seleção de um item
    onChangeSelectedItems = null,
    // controle de estado externo, valores do dataset que ja estao selecionados
    initialSelectedValues = null,
  } = props;
  // state
  const [remainingValues, setRemainingValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);

  // filter
  function filterDataSet(values) {
    return data.filter((item) => values.includes(item.value));
  }

  // on reset datas
  function handleReset() {
    // build remaining items
    const remainingItems = data
      .map((item) => item.value);
    // set remaining items
    setRemainingValues(remainingItems);
    setSelectedValues([]);
  }

  // on select item (chnage)
  function handleSelectItems(items) {
    // recupera o item selecionado (1 por vez)
    const selectedItem = items[0];
    // cria a lista de restantes
    const remainingItems = remainingValues.filter((value) => selectedItem.value !== value);
    // cria a lista de selecionados
    const selectedItems = [...selectedValues, selectedItem.value];
    // atualiza os estados
    setRemainingValues(remainingItems);
    setSelectedValues(selectedItems);
    // propaga o evento de seleção
    if (onChangeSelectedItems) onChangeSelectedItems(selectedItems);
    if (onSelectItem) onSelectItem(selectedItem);
  }

  // on select sub listitem
  function handleSelectListItem(itemId, subItemId) {
    if (onSelectedSubItem) onSelectedSubItem(itemId, subItemId);
  }

  // on remote item
  function handleRemoveListItem(itemId) {
    // cria a lista de restantes
    const remainingItems = [...remainingValues, itemId];
    // cria lista de selecionados
    const selectedItems = selectedValues.filter((value) => value !== itemId);
    // atualiza os estados
    setRemainingValues(remainingItems);
    setSelectedValues(selectedItems);
    // propaga o evento de seleção
    if (onChangeSelectedItems) onChangeSelectedItems(selectedItems);
    if (onRemoveItem) onRemoveItem(itemId);
  }

  // caso os dados de inicialização sejam alterados
  useEffect(() => {
    if (isNullOrEmptyArray(data)) {
      setRemainingValues([]);
      setSelectedValues([]);
    } else {
      // build remaining items
      const remainingItems = data
        .filter((item) => !selectedValues.includes(item.value))
        .map((item) => item.value);

      /**
       * Contabilizando itens selecionados automaticamente
       */
      if (initialSelectedValues) {
        const newSelectedValues = [...initialSelectedValues];
        setSelectedValues(newSelectedValues);

        initialSelectedValues.forEach((valueToBeRemoved) => {
          if (remainingItems.includes(valueToBeRemoved)) {
            const indexToRemove = remainingValues.findIndex((value) => value === valueToBeRemoved);
            remainingItems.splice(indexToRemove, 1);
          }
        });
      }


      // set remaining items
      setRemainingValues(remainingItems);
    }
  }, [data, initialSelectedValues, remainingValues, selectedValues]);

  // api para este componente poder
  // ser acesso pelo parent
  useImperativeHandle(ref, () => ({
    reset: () => {
      handleReset();
    },
  }));

  return (
    <Ui.Container>
      <div>
        <Selector
          dark={dark}
          optionWithIcon={false}
          data={filterDataSet(remainingValues)}
          onChange={handleSelectItems}
          enableFilter={enableFilter}
          placeholder={placeholder}
          inputSearchPlaceholder={inputSearchPlaceholder}
          selectedItensFormatter={() => placeholder}
        />
      </div>
      <div>
        <ListView
          selectable={subItemSelectable}
          data={filterDataSet(selectedValues)}
          onSelectItem={handleSelectListItem}
          onRemoveItem={handleRemoveListItem}
        />
      </div>
    </Ui.Container>
  );
}

const DetailedSelector = React.forwardRef(DetailedSelectorReferenciable);
export default DetailedSelector;
